<template>
  <v-container fluid>
    <v-row justify="space-between" no-gutters align="center">
      <v-col cols="12" md="5">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1">Simular financiamento</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pb-0 pt-0">
        <v-card class="px-4 py-4">
          <v-form ref="formFinanciamento">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
                <v-text-field-money
                  v-model="financiamento.sim_valor"
                  label="Valor do financiamento*"
                  :rules="[rules.required]"
                  :loading="salvando"
                  v-bind:properties="{
                    prefix: 'R$',
                    readonly: false,
                    disabled: salvando,
                    outlined: true,
                    clearable: true,
                    placeholder: ' ',
                  }"
                  v-bind:options="{
                    locale: 'pt-BR',
                    length: 15,
                    precision: 2,
                    empty: null,
                  }"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-autocomplete
                  v-model="financiamento.sim_tipo_calculo"
                  autocomplete="off"
                  :items="tipos"
                  :loading="salvando"
                  :disabled="salvando"
                  :rules="[rules.required]"
                  label="Tipo de cálculo*"
                  append-icon="expand_more"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="financiamento.sim_quantidade_parcelas"
                  label="Quantidade de parcelas*"
                  :rules="[rules.required]"
                  outlined
                  :disabled="salvando"
                  type="number"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="financiamento.sim_percentual_entrada"
                  label="Percentual de entrada*"
                  suffix="(%)"
                  :rules="[rules.required]"
                  type="number"
                  outlined
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
                <v-text-field
                  v-model="financiamento.sim_taxa_mensal"
                  label="Juros mensal*"
                  suffix="(%)"
                  :rules="[rules.required]"
                  outlined
                  type="number"
                  :disabled="salvando"
                  :loading="salvando"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mt-2 mb-4"></v-divider>
          <v-btn
            color="primary"
            class="w-100"
            @click="calcular()"
            :loading="salvando"
            :disabled="salvando"
          >
            Calcular
          </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="9" lg="9" xl="9" class="pb-0 pt-0">
        <v-card class="px-4 py-4">
          <div class="text-h2 mb-4">
            Resultado da simulação
          </div>
          <v-row no-gutters justify="space-between" align="center">
            <div>
              <div class="text text--thin mb-2">
                <b>Valor da parcela:</b> <span>{{$root.Formatter.floatToMoney(sim_parcela)}}</span>
              </div>
              <div class="text text--thin">
                <b>Valor da entrada:</b> <span>{{$root.Formatter.floatToMoney(sim_entrada)}}</span>
              </div>
            </div>
            <div>
              <div class="text text-md-right text-center">
                * Os valores são apenas uma simulação e podem sofrer alterações no momento da cotação
              </div>
              <div class="text text-md-right text-center mt-2">
                * Sujeito a aprovação de crédito
              </div>
            </div>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="dados"
            multi-sort
            :options.sync="options"
            loading-text="Carregando... Por favor aguarde"
            :loading="carregando"
            class="elevation-1 base_table mt-4"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="end">
                <div class="py-2 px-2">
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls()">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Api from '@API'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'
export default {
  data () {
    return {
      search: '',
      total: 0,
      carregando: false,
      options: {},
      salvando: false,
      financiamento: {
        sim_valor: '',
        sim_tipo_calculo: 1,
        sim_quantidade_parcelas: '',
        sim_percentual_entrada: '',
        sim_taxa_mensal: ''
      },
      tipos: [
        {
          text: 'Tabela Price',
          value: 1
        },
        {
          text: 'Tabela Sac',
          value: 2
        }
      ],
      headers: [
        { text: 'Parcela', value: 'parcela' },
        { text: 'Valor da parcela', value: 'valor_parcela' },
        { text: 'Juros', value: 'juros' },
        { text: 'Amortização do saldo devedor', value: 'amortizacao' },
        { text: 'Saldo devedor', value: 'saldo_devedor' }
      ],
      dados: [],
      sim_parcela: '',
      sim_entrada: '',
      rules: {
        required: value => !!value || 'Obrigatório.'
      }
    }
  },
  methods: {
    calcular () {
      if (!this.$refs.formFinanciamento.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      this.carregando = true
      Api.post('financiamentos/simulacao', this.financiamento)
        .then((res) => {
          this.salvando = false
          this.carregando = false
          if (res.data.error) {
            this.$root.SnackControl.open(this, {
              text: res.data.error,
              color: 'error'
            })
            return false
          }
          if (res.data) {
            this.sim_entrada = res.data.entrada
            this.sim_parcela = res.data.valor_parcela
            let parcelas = []
            if (res.data.parcelamento.length > 0) {
              res.data.parcelamento.map(item => {
                parcelas.push({
                  parcela: item.parcela,
                  valor_parcela: this.$root.Formatter.floatToMoney(item.valor_parcela),
                  amortizacao: this.$root.Formatter.floatToMoney(item.amortizacao),
                  juros: this.$root.Formatter.floatToMoney(item.juros),
                  saldo_devedor: this.$root.Formatter.floatToMoney(item.saldo_devedor)
                })
              })
            }
            this.dados = parcelas
          }
        })
        .catch((error) => {
          this.salvando = false
          this.carregando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    exportPdf (type = null) {
      let dados = this.dados
      this.$root.Printer.openDialog(this, {
        titulo: 'Simulação de Financiamento', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: dados,
        headers: this.someHeader(this.headers), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    async exportXls (type = null) {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(this.headers),
        items: this.financiamento,
        type: 'simulacao-financiamento'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações') cabecalhos.push(header)
      })
      return cabecalhos
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    loadFunctions () {},
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Financiamento.vue